module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-2 px-4"
  }, [_c('div', {
    staticClass: "bg-lightest radius-normal border-light d-flex my-4 px-3"
  }, [(_vm.hasExtras) ? _c('div', {
    staticClass: "col-sm-12 pt-3"
  }, [_c('div', {
    staticClass: "w-100 darker font-weight-600"
  }, [_vm._v("Extras")]), _vm._v(" "), _c('extra-selector', {
    attrs: {
      "reservation": _vm.reservation
    }
  })], 1) : _c('div', {
    staticClass: "text-center dark fs-largest pt-5 text-center mb-4 w-100"
  }, [_vm._v("\n            This event has no extras\n        ")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-466cba20", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-466cba20"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/AddExtra.vue
// module id = 2909
// module chunks = 0